import { Component, Renderer } from '@angular/core';
import { CreateDialogPersonalStateService } from './create-quest/create.dialog.state.service';
import { StorageUtil } from '../../../utils/storage.util';
import { DashboardHttpUtil } from '../dashboard.util';
import { AuthUtil } from '../../../utils/auth.utils';
import { PersonalHttpService } from '../../../services/personal/personal.http.service';
//attachments
import { ContractModelService } from '../contracts/contracts.model.service';
import { DocumentsHttpService } from '../../../services/documents/documents.http.service';
import { ContractsHttpUtil } from '../contracts/contracts.util';
import { CreateSignatureDialogContractStateService } from '../contracts/signature/signature.modal.state.service';


@Component({
  moduleId: module.id,
  templateUrl: 'personal.component.html',
  providers: []
})

export class PersonalComponent {

  model: any = {
    id: '',
    inn: '',
    regDate: '',
    okfs: {
      code: '',
      name: '',
    },
    okveds: [],
    banks: [],
    documents: [],

    //   ФЛ
    ip: '',
    snils: '',
    ogrnip: '',
    lastName: '',
    name: '',
    patronymic: '',
    address: '',

    //   ЮЛ
    //   name: '',
    ogrn: '',
    opf: {
      code: '',
      name: '',
    },
    kpp: '',
    chief: {
      name: '',
      position: '',
    },
    phone: '',
    email: '',
    legalAddress: {
      postcode: '',
      address: '',
    },
    postAddress: {
      postcode: '',
      address: '',
    },
  };

  pageLoading: boolean = true;
  errorMessage: string;
  bankAccordionStatus: boolean = false;
  loadingFile: boolean = false;

  constructor(private createDialogPersonalStateService: CreateDialogPersonalStateService,
              private personalHttpService: PersonalHttpService,
              private authUtil: AuthUtil,
              private renderer: Renderer,
              private createSignatureDialogService: CreateSignatureDialogContractStateService,
              private contractModelService: ContractModelService,
              private documentsHttpService: DocumentsHttpService
  ) {}

  ngOnInit() {
    let requestParams = DashboardHttpUtil.prepareTokenParam(StorageUtil.getToken());
    this.personalHttpService.getTenant(requestParams).subscribe(
      success => {
        if (success) {
          this.pageLoading = false;
          let data = success.json();
          if(this.authUtil.isError(data)) {
            this.errorMessage = this.authUtil.errorMessage(data);
              this.authUtil.checkErrorResponse(data);

          } else {
            this.model = data.response;
          }
        }
      },
      error => {
        this.errorMessage = 'Произошла ошибка.';
        this.pageLoading = false;
      },
      () => {
        this.pageLoading = false;
      });
  }

  ngAfterViewInit() {
    this.renderer.setElementClass((<any>document.getElementById('wrapper')), 'card', true);
  }

  openChatDialog($event) {
    $event.preventDefault();
    this.createDialogPersonalStateService.triggerDialogStatus({display: true})
  }

  toggleBankAccorion($event) {
    $event.preventDefault();
    this.bankAccordionStatus = !this.bankAccordionStatus;
  }

  ngOnDestroy() {
    this.renderer.setElementClass((<any>document.getElementById('wrapper')), 'card', false);
  }

  acceptSign(attach) {
      let ext = attach.name.split('.').pop();
      return ext === 'docx' || ext === 'pdf';
  }

  download($event, attach) {
    $event.preventDefault();
	if (this.loadingFile) {
	  return false;
    }

    this.loadingFile = true;

    let data = {
      securityToken: StorageUtil.getToken(),
    };

    let requestParams = ContractsHttpUtil.prepareParamsDownload(data);
    this.documentsHttpService.getDocument(requestParams, attach.id)
      .map(res => {
        if(res.headers.get('content-disposition')) {
          return res.blob();
        }
      })
      .subscribe(
        blobContent => {
          this.loadingFile = false;
          if(blobContent) {
            saveAs(blobContent, attach.name);
          } else {
          }
        },
        error => {
          this.loadingFile = false;
        },
        () => {
          this.loadingFile = false;
        });
  }

  openSignatureDialog($event, attach, model) {
      $event.preventDefault();
      this.createSignatureDialogService.triggerDialogStatus({display: true, attach: attach, model: model});
  }


}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/personal/personal.component.ts